import { render, staticRenderFns } from "./HeaderAggregate.vue?vue&type=template&id=3e34e97b&scoped=true&"
import script from "./HeaderAggregate.vue?vue&type=script&lang=js&"
export * from "./HeaderAggregate.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAggregate.vue?vue&type=style&index=0&id=3e34e97b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e34e97b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VCardText,VRating})
